/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Starts Boost 205254 */
const customize = {
    crossOOSProductSwatches: (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductSwatch", {
            name: "Cross out OOS swatches",
            enabled: true,
            apply: () => ({
                props(props, element) {
                    try {
                        props.options = props.options.sort(function(a, b) {
                            let firstValue = a.value;
                            let secondValue = b.value;
                            firstValue = firstValue.split(' / ')[0].replace('UK', '').replace('EUR', '').replace('US', '').replace('EU', '').trim();
                            secondValue = secondValue.split(' / ')[0].replace('UK', '').replace('EUR', '').replace('US', '').replace('EU', '').trim();
                            
                            if (parseInt(firstValue) < parseInt(secondValue)) {
                                return -1;
                            }
                            if (parseInt(firstValue) > parseInt(secondValue)) {
                                return 1;
                            }
                            return 0;
                        })
                    } catch(error) {
                        console.log(error);
                    }
                    
                    return props;
                },
                afterRender(element) {
                    const swatchOptions = element?.getParams()?.props?.options;
                    const productData = componentRegistry
                        .getNearestParentElm(element, "QuickView")
                        ?.getParams()?.props?.productData;
                    if (swatchOptions?.length && productData) {
                        const productVariants = productData.variants || [];

                        swatchOptions.forEach((option) => {
                            const optionValue = option.value;

                            optionAvailable = productVariants.find(variant => variant.title == optionValue.trim()).available;
                            if (optionAvailable == false) {
                                const swatchOption = document.querySelector(
                                    `label[for*="${option.id}"]`
                                );

                                if (
                                    swatchOption &&
                                    swatchOption.closest(".boost-sd__product-swatch-option")
                                ) {
                                    swatchOption
                                        .classList.add("sold-out");
                                }
                            }
                        });
                    }
                },
            }),
        });
    },
};


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.crossOOSProductSwatches,
]);

/* Ends Boost 205254 */